import Phaser from 'phaser';

import gameConfig from '../../../config/game';


export default class GameStartScr{

    constructor(){
        GAME_REF.obj.startscr = this;
        this.scene = GAME_REF.scene;

        this.manager = GAME_REF.obj.manager;
        this.sound = GAME_REF.obj.sound;
        this.dragon = GAME_REF.obj.dragon;
        
        this._init();
    }


    render(){

        this.scene.tweens.add({
            targets: this.title,
            alpha: 1,
            scaleX: 1,
            scaleY: 1,
            duration: 500,
            delay: 1000,
            ease: 'Back.easeOut',
        });

        this.sound.playSequence(['se_bgm', 'title_na1', 'title_na2'], ()=>{
            this.manager.kaisetsu();
        });
        this.sound.setOnSequenceOneStart(key => {

            if(key==='title_na2'){
                this.dragon.jump();
            }
        });

        setTimeout(()=>{
            this.dragon.jump();
        }, 1000)
        
    }


    hide(){

        this.scene.tweens.add({
            targets: this.title,
            alpha: 0,
            duration: 500,
            delay: 500,
            ease: 'Cubic.easeOut', 
        });
    }


    _init(){
        this._create();
    }

    _create(){
        this.title = this.scene.add.image(645, 190, 'title');
        this.title.alpha = 0;
        this.title.setScale(1.3);
    }
}